module.exports = __webpack_public_path__ + "img/gj_jkwz.fb97f555.png";